export interface SearchAndReplaceInspectorState {
    value: SearchAndReplaceFormValue;
    error?: string;
    preview?: SearchAndReplacePreviewData;
    isPreviewLoading: boolean;
    isReplaceLoading: boolean;
    visible: boolean;
}

export interface SearchAndReplaceFormValue {
    searchValue: string;
    searchOptionValue: SearchOption;

    replaceValue: string;
    replaceOptionValue: ReplaceOption;

    searchByRadioButtonValue: SearchByRadioButton;
    matchCase: boolean;
    wholeWords: boolean;
}

export enum SearchOption {
    ALL = 'ALL',
    SEARCH = 'SEARCH'
}

export enum ReplaceOption {
    REPLACE = 'REPLACE',
    ADD_TO_START = 'ADD_TO_START',
    ADD_TO_END = 'ADD_TO_END'
}

export enum SearchByRadioButton {
    PHRASE = 'PHRASE',
    MINUS_WORDS = 'MINUS_WORDS'
}

export interface SearchAndReplacePreviewData {
    items: SearchAndReplaceInspectorPreviewItem[];
    cacheKey: string;
    totalCount: number;
}

export interface SearchAndReplaceInspectorPreviewItem {
    oldValue: string;
    newValue: string;
}
